import React,{ useState} from 'react';
import { useSelector,  connect} from 'react-redux';
import * as actionsPolicy  from '../../../../app/actions/policy';
import {isCyrilicFound, isLatinFound, getLatin} from '../../../../app/common/services/vehicle.service';
import { NuInsInputTextLabel, NuInsInputNumLabel } from '../elements/inputFieldsLabel';
import { CheckBoxCustom } from '../elements/inputFields';

const OwnerDetailsPerson = ({updateOwnerDetails, onSubmit}) => {

    const ownerDetails = useSelector(state => state.ownerDetails);
    const userDetails = useSelector(state => state.userDetails);

    const hasUserDetails = Object.keys(userDetails).length;

   // console.log(userDetails)

    const [checkFields, setCheckFields] = useState({});

    const [sameOwner, setSameOwner] = useState(false);

    const inputFields = ['firstNameCyrillic', 'middleNameCyrillic', 'lastNameCyrillic', 'firstName', 'middleName', 'lastName', 'personPublicId'];
    const errorMsg    = "Полето е задължително";

    const onSameOwnerChange = (data) => {
        setSameOwner(data);
        if(data && hasUserDetails) {
            const {firstNameCyrillic, middleNameCyrillic, lastNameCyrillic, firstName, middleName, lastName, personPublicId} = userDetails;
            updateOwnerDetails({firstNameCyrillic, middleNameCyrillic, lastNameCyrillic, firstName, middleName, lastName, personPublicId});
        } else {
            updateOwnerDetails({firstNameCyrillic: null, middleNameCyrillic: null, lastNameCyrillic: null, 
                                        firstName: null, middleName: null, lastName: null, personPublicId: null});
        }
    }

    const onChangeHandler = (field, data) =>  {
        if(field.includes('Cyrillic')) {
            const latinField = field.substring(0, field.length-8);
            updateOwnerDetails({[field]: data, [latinField]: getLatin(data)});
        } else {

            updateOwnerDetails({[field]: data});
        }
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'cyrilic':
                const nonCyrFound = ownerDetails[field] ? isLatinFound(ownerDetails[field]) : false;
                return (checkFields[field] || allFields) && (nonCyrFound || !ownerDetails[field]);
            case 'latin':
                const cyrFound = ownerDetails[field] ? isCyrilicFound(ownerDetails[field]) : false;
                return (checkFields[field] || allFields) && (cyrFound || !ownerDetails[field]);
            case 'id':
                return (checkFields[field] || allFields) && (!ownerDetails[field] || (ownerDetails[field]?.length < 10));
            default:
                return (checkFields[field] || allFields) && !ownerDetails[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return `${errorMsg} ${ownerDetails[field] ? 'на кирилица' : ''}`;
            case 'latin':
                return `${errorMsg} ${ownerDetails[field] ? 'на латиница' : ''}`;
            case 'id':
                return `${errorMsg} ${ownerDetails[field] ? '10 символа' : ''}`;
            default:
                return errorMsg;
        }
    }

    const valdateAllFields = () => {

        for(let field of inputFields) {
            if(field.includes('Cyr')) {
                if(checkForError(field, 'cyrilic', true)) return false;
            } else if ('firstName_middleName_lastName'.includes(field)) {
                if(checkForError(field, 'latin', true)) return false;
            } else if (field === 'personPublicId') {
                if(checkForError(field, 'id', true)) return false;
            } else {
                if(checkForError(field, null, true)) return false;
            }
        }

        return true;
    }

    const submitHandler = () => {
        setCheckFields(inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {}));

        if(valdateAllFields()) {
            onSubmit();
        }
    }

    return (
        <div className="steps_container-form show-loading" >

            <h6 style={{paddingLeft:"2rem", fontWeight: '500'}}>Собственик </h6>
            <h6 style={{paddingLeft:"2rem",color:"#6bdfa7", fontWeight: '500', marginBottom: '1rem'}}>Физическо лице</h6>

            { hasUserDetails
            ? <div className="steps_container-checkbox" style={{marginBottom: '20px'}}>
                    <CheckBoxCustom onChange={(data) => onSameOwnerChange(data)} value={sameOwner}/>
                    <div>Аз съм собственик на застрахованото МПС</div>
              </div>
            : null}

            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('firstNameCyrillic', data)} onBlur={()=>onBlurHandler('firstNameCyrillic')} 
                placeholder={"Име"} 
                value={ownerDetails['firstNameCyrillic']} 
                error={checkForError('firstNameCyrillic', 'cyrilic')} 
                errorMsg={generateErrorMsg('firstNameCyrillic', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>
          
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('middleNameCyrillic', data)} onBlur={()=>onBlurHandler('middleNameCyrillic')} 
                placeholder={"Презиме"} 
                value={ownerDetails['middleNameCyrillic']} 
                error={checkForError('middleNameCyrillic', 'cyrilic')} 
                errorMsg={generateErrorMsg('middleNameCyrillic', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>
      
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('lastNameCyrillic', data)} onBlur={()=>onBlurHandler('lastNameCyrillic')} 
                placeholder={"Фамилия"} 
                value={ownerDetails['lastNameCyrillic']} 
                error={checkForError('lastNameCyrillic', 'cyrilic')} 
                errorMsg={generateErrorMsg('lastNameCyrillic', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>
           
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('firstName', data)} onBlur={()=>onBlurHandler('firstName')} 
                placeholder={"Име на латница"} 
                value={ownerDetails['firstName']} 
                error={checkForError('firstName', 'latin')} 
                errorMsg={generateErrorMsg('firstName', 'latin')}
                styles={{marginBottom: '20px'}}/>
         
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('middleName', data)} onBlur={()=>onBlurHandler('middleName')} 
                placeholder={"Презиме на латница"} 
                value={ownerDetails['middleName']} 
                error={checkForError('middleName', 'latin')} 
                errorMsg={generateErrorMsg('middleName', 'latin')}
                styles={{marginBottom: '20px'}}/>
        
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('lastName', data)} onBlur={()=>onBlurHandler('lastName')} 
                placeholder={"Фамилия на латница"} 
                value={ownerDetails['lastName']} 
                error={checkForError('lastName', 'latin')} 
                errorMsg={generateErrorMsg('lastName', 'latin')}
                styles={{marginBottom: '20px'}}/>
           
            <NuInsInputNumLabel onChange={(data)=>onChangeHandler('personPublicId', data)} onBlur={()=>onBlurHandler('personPublicId')} slice={10} 
                placeholder={"ЕГН"} 
                value={ownerDetails['personPublicId']} 
                error={checkForError('personPublicId', 'id')} 
                errorMsg={generateErrorMsg('personPublicId', 'id')}/>

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={submitHandler}>Продължи</button>

        </div>
    )

}

export default connect(null, {...actionsPolicy})(OwnerDetailsPerson);